<div class="timeline timeline-line-dotted">
    <span class="timeline-label">
        <span class="highlighting group">{{tlGroup.eventDateUtc | formatShortDate9 }}</span>
    </span>
    <aa-timeline-item *ngFor="let tlItem of tlGroup.timelineItems" [tlItem]="tlItem"></aa-timeline-item>
</div>
